import * as Surplus from "surplus";
import "./_loader.scss";

export function Loader() {
    return (
        <svg
            class="lds-spinner"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid">
            <g transform="rotate(0 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.7272727272727273s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(32.72727272727273 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.6545454545454545s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(65.45454545454545 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.5818181818181819s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(98.18181818181819 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.5090909090909091s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(130.9090909090909 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.43636363636363645s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(163.63636363636363 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.36363636363636365s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(196.36363636363637 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.29090909090909095s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(229.0909090909091 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.21818181818181823s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(261.8181818181818 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.14545454545454548s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(294.54545454545456 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="-0.07272727272727274s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
            <g transform="rotate(327.27272727272725 50 50)">
                <rect x="44" y="7.5" rx="44" ry="7.5" width="12" height="25" fill="#f3dcb2">
                    <animate
                        attributeName="opacity"
                        values="1;0"
                        keyTimes="0;1"
                        dur="0.8s"
                        begin="0s"
                        repeatCount="indefinite"
                    />
                </rect>
            </g>
        </svg>
    );
}
